<template>
	<div class="raw-transactions">
		<Accordion
			title="Raw Transactions"
			v-model="accordion.first"
			v-log="{
				event: 'open',
				target: 'TransactionAudit.RawViewed',
				eventData: {
					...auditInfo,
					action: 'Viewed',
					target: 'Raw'
				}
			}"
		>
			<template #body-content>
				<div class="raw-transactions__container">
					<div class="raw-transactions__header-actions">
						<ButtonGroup>
							<template slot="container">
								<Button
									className="btn--has-icon btn--small"
									labelText="Download"
									:btnClick="downloadFile"
									:iconClassName="'icon icon-download'"
									:iconBeforeLabel="true"
									v-log="{
										event: 'click',
										target: 'TransactionAudit.RawDownload',
										eventData: {
											...auditInfo,
											action: 'Downloaded',
											target: 'Raw'
										}
									}"
								></Button>
								<Button
									className="btn--has-icon btn--small"
									labelText="Copy"
									:btnClick="copy"
									:iconClassName="'icon icon-copy'"
									:iconBeforeLabel="true"
									v-log="{
										event: 'click',
										target: 'TransactionAudit.RawCopied',
										eventData: {
											...auditInfo,
											action: 'Copied',
											target: 'Raw'
										}
									}"
								></Button>
							</template>
						</ButtonGroup>
					</div>
					<!-- DEV NOTE: Each detail of log content should break line after the comma ",". Please see approved mockups for reference -->
					<div class="raw-transactions__details">
						<pre>{{ pretty(log) }}</pre>
					</div>
				</div>
			</template>
		</Accordion>
	</div>
</template>

<script>
import Accordion from '@/components/shells/accordion/accordion';
import ButtonGroup from '@/components/forms/button/button-group';
import Button from '@/components/forms/button/button';
import { copyToClipboard } from '@/utils/function';
import { LoggingMixin } from 'vue-ui-layout';
import store from '@/store';

export default {
	name: 'GlobalTransactionsDetailRawTransactions',
	mixins: [LoggingMixin],
	components: {
		Accordion,
		ButtonGroup,
		Button
	},
	props: {
		log: {
			type: String,
			default: ''
		},
		auditInfo: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			accordion: {
				first: false
			}
		};
	},
	methods: {
		downloadFile() {
			if (this.log) {
				const rawTransaction = this.pretty(this.log);
				const parseRawTransaction = JSON.parse(this.log);
				const { LogId } = parseRawTransaction;
				const LogName = `raw-transaction ${LogId}`;
				const blob = new Blob([rawTransaction], {
					type: 'application/json'
				});
				const blobURL = URL.createObjectURL(blob);
				const downloadLink = document.createElement('a');
				downloadLink.href = blobURL;
				downloadLink.download = `${LogName}.txt`;
				downloadLink.click();
			}
		},
		copy() {
			if (this.log) {
				const logPretty = JSON.stringify(JSON.parse(this.log), null, 2);
				copyToClipboard(logPretty);

				store.dispatch('toastMessages/push', {
					statusCode: 200,
					message: 'Raw Transaction copied to clipboard!!'
				});
			}
		},
		pretty(value) {
			if (value) {
				return JSON.stringify(JSON.parse(value), null, 2);
			}
			return '';
		}
	}
};
</script>

<style lang="scss">
/**
  * Transaction Details - Raw Transactions
  * Can use SCSS variables = TRUE
**/

.raw-transactions {
	&__header-actions {
		display: flex;
		justify-content: flex-end;
		padding: $padding-md;
		border-bottom: 1px solid $neutral-2;

		@include mq($from: sm-l) {
			padding: $padding-md $padding-lg;
		}
	}

	&__details {
		padding: $padding-md;
		overflow: auto;
		max-height: 180px;
		@include scrollbar;
		font-size: $default-font-size - 4;
	}
}
</style>
